export default __webpack_public_path__ + "static/media/innisfreeSunscreen.1487c975.jpg";